import { TInviteRequest } from '@gen2/api/invite-requests/api';
import { RequestGroup } from '../shared-drawer';
import { SortableRequestItemProps } from '../sortable-request-list/sortable-request-item';
import { RequestListType } from '../sortable-request-list/sortable-request-list';
import { useSharedDrawerStore } from '../store';
export interface OpenSharedDrawerProps {
    type?: RequestListType;
    inviteId?: string;
    followUpId?: string;
    templateId?: string;
    items?: SortableRequestItemProps[] | TInviteRequest[];
    itemsToGroup?: RequestGroup[];
}

export const useOpenSharedDrawer = () => {
    const { setIsOpen, setConfig } = useSharedDrawerStore();

    const openSharedDrawer = (props: OpenSharedDrawerProps) => {
        const {
            type = 'invite',
            inviteId,
            followUpId,
            templateId,
            items,
            itemsToGroup,
        } = props;

        setConfig({
            title: 'Organize Requests',
            contentProps: {
                type,
                ...(inviteId && { inviteId }),
                ...(templateId && { templateId }),
                ...(followUpId && { followUpId }),
                ...(items && { items }),
                ...(itemsToGroup && { itemsToGroup }),
            },
        });

        setIsOpen(true);
    };
    return openSharedDrawer;
};